import { base as viemBase } from 'viem/chains'

import type { AppChain } from './chain.types'

export const base = {
  ...viemBase,
  custom: {
    name: 'Base Mainnet',
    shortName: 'Base',
    morphoChainSlug: 'base',
    isIconSquare: true,
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://basescan.org', name: 'BaseScan' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x46415998764C29aB2a25CbeA6254146D50D22687',
          startBlock: 13977148n
        },
        MorphoBlue: {
          address: '0xBBBBBbbBBb9cC5e90e3b3Af64bdAF62C37EEFFCb',
          startBlock: 13977148n
        },
        MetaMorphoV10Factory: {
          address: '0xA9c3D3a366466Fa809d1Ae982Fb2c46E5fC41101',
          startBlock: 13978134n
        },
        MetaMorphoV11Factory: {
          address: '0xFf62A7c278C62eD665133147129245053Bbf5918',
          startBlock: 23928808n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x4501125508079A99ebBebCE205DeC9593C2b5857',
          startBlock: 35615206n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0x133baC94306B99f6dAD85c381a5be851d8DD717c',
          startBlock: 35615206n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x9a1B378C43BA535cDB89934230F0D3890c51C0EB',
          startBlock: 39285528n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xF42D9c36b34c9c2CF3Bc30eD2a52a90eEB604642',
          startBlock: 35615206n
        },
        RegistryList: {
          address: '0x5C2531Cbd2cf112Cf687da3Cd536708aDd7DB10a',
          startBlock: 35615358n
        },
        Midnight: {
          address: '0xAdedD8ab6dE832766Fedf0FaC4992E5C4D3EA18A',
          startBlock: 48286884n
        },
        MidnightMempool: {
          address: '0xdD6DCE32e21f7b020898a8258dA37355b4017993',
          startBlock: 48286884n
        },
        MidnightBundles: {
          address: '0x091183d729BE9f808c212b475E387A12E67850A7',
          startBlock: 48286997n
        },
        EcrecoverRatifier: {
          address: '0xd6e70365C8E8DDa9a4ca662C07bbE663b017755E',
          startBlock: 48286884n
        },
        SetterRatifier: {
          address: '0x800B5F12A61B8198a5a6EfD794Cac6699B294d63',
          startBlock: 48286884n
        },
        EcrecoverAuthorizer: {
          address: '0x292bEa9f1443d54E0E509120c919106765c6a493',
          startBlock: 48286884n
        },
        BlueBuyCallbackFactory: {
          address: '0x7337f119Eca028bD39E0e543cEf71631D2333425',
          startBlock: 49544552n
        },
        BluePublicAllocator: {
          address: '0xAED282B8aD9257BB1272e93aE63A32A53621e412',
          startBlock: 50063965n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: true }>
